module.exports = __webpack_public_path__ + "static/media/YF52_1.1b1e918b.jpg";